import FJViewConstant from '../constants/FJViewConstant';

const FPS = 30;

export default {
    /**
     * 全局人脸检测调度器 `FJFaceDetectScheduler` 允许同时执行的任务数（≥1，默认 1）。
     * 与 `runFaceDetectSerial` 的「多片段依次执行」无冲突；用于限制跨会话/多入口时并行 `startDetectFace` 的数量。
     */
    FACE_DETECT_MAX_CONCURRENT: 1,
    /**
     * SSD 人脸检测最小置信度（约 0～1）。**提高**可减轻玩具、海报等类人脸误检，但侧脸/小脸/略糊片段漏检会略增。
     */
    FACE_DETECT_MIN_CONFIDENCE: 0.55,
    /**
     * 主体检测兜底开关：人脸为空帧调用 U²-Net 识别画面主体并作为虚拟人脸框注入。
     * 关闭时维持现有行为（无脸帧 facesData 为空）。模型 URL 见 `FJConfig.SUBJECT_MODEL_URL`。
     */
    SUBJECT_DETECT_ENABLED: true,
    /**
     * 推理后端：`webgpu` / `wasm`（transformers.js ONNX 不支持 webgl）。
     * 需 @huggingface/transformers ≥4.x + 新版 ORT WebGPU（已修复 MaxPool ceil_mode）。
     * 浏览器不支持 WebGPU 时自动降级 wasm。
     */
    SUBJECT_DETECT_DEVICE: 'webgpu',
    /** mask 二值化阈值（0~1）。提高使 bbox 收紧（可能漏掉边缘弱主体）；降低使 bbox 扩张。 */
    SUBJECT_DETECT_THRESHOLD: 0.72,
    /**
     * 详情/内嵌预览：canvas 实际像素长边上界（约 720p 长边）。
     * 显示尺寸仍由布局 contain；仅提高离屏绘制清晰度。
     */
    VIDEO_PREVIEW_MAX_LONG_EDGE: 720,
    isAsyncUpdate: true,
    needExport: false,
    needUploadAudio: false,
    defaultSceneDuration: 5,
    trackNodeBoxShadow: '0 0 3px 0 rgba(0,0,0,0.50)',
    default_horizontal_resize: 'ew-resize',
    default_vertical_resize: 'ns-resize',
    default_nw_resize: 'nesw-resize',
    default_se_resize: 'nwse-resize',
    default_rotateCursor: 'pointer',
    adsorptionOffsetRatio: 10 / 500, //文字吸附辅助线距离边界的距离 = ratio * width
    adsorptionOffset: 6, //有效吸附距离
    trackLinkNormalColor: '#fff',
    fontFamily: 'Montserrat', // 动画文字字体
    fontBold: false,
    fontItalic: false,
    minFontSize: 13, // 字体最小值
    refSize: { width: 1920, height: 1080 },
    minElementSize: 5,
    FPS: FPS,
    reFPS: 1 / FPS,
    textWidthAllowErrorAmount: 20, // 文字误差宽度
    minAnimationDuration: 0.05, // 进出场动画的时长最小值 s
    maxAnimationDuration: 5, // 进出场动画的时长最大值 s
    minMediaDuration: 0.1, //最小媒体时长
    dragToCanvasPositionOffset: 20,
    // track 属性
    trackNodeNormalStrokeColor: '#ffffff',
    trackNodeSelectedFillColor: '#ffffff',
    trackNodeSelectedStrokeColor: '#ffffff',
    trackRotateNormalColor: '#1A1B1C',
    trackNodeNormalFillColor: '#ffffff',
    trackRotateSelectedColor: '#FF822C',
    trackStretchNormalColor: '#fff',
    updateReferSize: function (ratio) {
        let refW = 1920;
        let refH = 1080;
        let r = refW / refH;
        if (r > ratio) {
            this.refSize.height = refH;
            this.refSize.width = Math.round(refH * ratio);
        } else {
            this.refSize.width = refW;
            this.refSize.height = Math.round(refW / ratio);
        }
    },
    defaultSubtitleStyle: {
        fontFamily: 'Roboto',
        fontSize: 50,
        fontColor: '#FFFFFF',
        background: {
            enabled: true,
            color: '#000000',
            opacity: 0.4,
            radius: 0.3,
            hasFollowText: true,
            padding: {
                left: 30,
                right: 30,
                top: 20,
                bottom: 20,
            },
        },
        padding: {
            left: 30,
            right: 30,
            top: 20,
            bottom: 20,
        },
        isBold: false,
        isItalic: false,
        alignment: 'center',
        spacing: 0,
        lineHeight: 7 / 6,
        opacity: 1,
        subtitleStyle: {
            type: 'NONE',
            info: {},
        }, // 不能是style，因为和fromJson的style重名，并且style和subtitleStyle的数据不同
        angle: 0,
        relativeRect: {
            x: 0.14,
            y: 0.74,
            width: 0.72,
            height: 0.08,
        },
        animationInName: 'None',
        textCombinationType: 'character', //word

        animationTextColor: '',
        animationBackgroundColor: '',
        anchorTextDirection: FJViewConstant.ANCHOR_CENTER,
        EXPORT_RATIOS: {
            '9:16': [9, 16],
            '16:9': [16, 9],
            '1:1': [1, 1],
            '4:5': [4, 5],
            '3:4': [3, 4],
            '21:9': [21, 9],
            '2:1': [2, 1],
        },
    },
};
